import { i18n } from 'boot/i18n'

const apis = {
  modes: {
    Riconducibille: i18n.t('reconducible'),
    Privata: i18n.t('private'),
    Sociale: i18n.t('social'),
  },
  tipoPagamento: {
    it: {
      // ' ': 'Altro',
      A: i18n.t('payment_type.bank_check'),
      C: i18n.t('payment_type.cash'),
      P: i18n.t('payment_type.pos'),
      B: i18n.t('payment_type.bank'),
      M: i18n.t('payment_type.poste'),
      O: i18n.t('payment_type.gift'),
      L: i18n.t('payment_type.legal'),
      I: `${i18n.t('vat')} ASL`,
      E: `${i18n.t('bank')} ASL`,
    },
    pt: {
      // P: 'CARTAO DE CREDITO',
      'P': i18n.t('payment_type.pos'),
      // P: 'CARTAO DE DEBITO',
      // M: i18n.t('payment_type.poste'), // da cambiare

      // CHEQUE BANCARIO
      'A': i18n.t('payment_type.bank_check'),

      // REFERENCIA MULTIBANCO

      // NUMERARIO
      'C': i18n.t('payment_type.cash'),

      // OUTROS
      ' ': 'OUTROS',

      // TRANSFERENCIA BANCARIA OU DEBITO DIRECTO
      'B': i18n.t('payment_type.bank2'),

      // FINANCIAMENTO / CREDITO
    },
  },
  paCondizioni: {
    TP01: 'Pagamento a rate',
    TP02: 'Pagamento completo',
    // TP03: 'Anticipo'
  },
  paModalita: {
    MP01: 'Contanti',
    MP02: 'Assegno',
    MP03: 'Assegno circolare',
    MP04: 'Contanti presso Tesoreria',
    MP05: 'Bonifico',
    MP06: 'Vaglia cambiario',
    MP07: 'Bollettino bancario',
    MP08: 'Carta di pagamento',
    MP09: 'RID',
    MP10: 'RID utenze',
    MP11: 'RID veloce',
    MP12: 'RIBA',
    MP13: 'MAV',
    MP14: 'Quietanza erario',
    MP15: 'Giroconto su conti di contabilità speciale',
    MP16: 'Domiciliazione bancaria',
    MP17: 'Domiciliazione postale',
    MP18: 'Bollettino di c/c postale',
    MP19: 'SEPA Direct Debit',
    MP20: 'SEPA Direct Debit CORE',
    MP21: 'SEPA Direct Debit B2B',
    MP22: 'Trattenuta su somme già riscosse',
  },
}
export default {
  namespaced: true,

  getters: {
    toLabelValue: (_, __, ___, rootGetters) => key => {
      const lang = rootGetters['auth/locale'] === 'pt' ? 'pt' : 'it'
      const values = key === 'tipoPagamento' ? apis[key][lang] : apis[key]
      return Object.entries(values).map(([value, label]) => ({ value, label }))
    },
    limited: (_, __, rootState) => rootState.apis.paymentTypes.filter(({ TipoPagamento }) => ['A', 'C', 'P'].includes(TipoPagamento)),

    getPaymentType: (_, __, ___, rootGetters) => id => rootGetters['apis/getObj']({ id, key: 'paymentTypes' }),

    getPTypeFromKey: (_, __, ___, rootGetters) => (val, key) => {
      const lang = rootGetters['auth/locale'] === 'pt' ? 'pt' : 'it'
      return (key === 'tipoPagamento' ? apis[key][lang] : apis[key])[val]
    },
    // getPTypeFromId: (_, { getPaymentType }) => (id, key, field) => apis[key][getPaymentType(id)[field]],

    getPaymentTypeMode: (_, { getPaymentType }) => id => {
      const { Riconducibille, Privata, Sociale } = getPaymentType(id)
      if (Riconducibille) return 'Riconducibile'
      if (Privata) return 'Privato'
      if (Sociale) return 'Sociale'
      return ''
    },

    // byType: state => type => state.items
    //   .filter(({ Riconducibille, Privata, Sociale }) => {
    //     if (type === 'Riconducibile') return Riconducibille
    //     if (type === 'Privato') return Privata
    //     if (type === 'Sociale') return Sociale
    //   })
    //   .map(c => ({ label: c.full, value: c.Id }))
  },
}
